import Sidebar from "../components/Sidebar";
import ListCareer from "../components/ListCareer";
import { useMobileStatus } from "../hooks/useMobileStatus";
import MobileHeader from "../components/MobileHeader";

const LoginSuccess = () => {
  const isMobile = useMobileStatus();
  return (
    <div className="container-big">
      {!isMobile && <Sidebar />}
      <div className="container-main">
        {isMobile && <MobileHeader />}
        <ListCareer />
      </div>
    </div>
  );
};

export default LoginSuccess;
